<div class="artikel-wrapper mat-elevation-z2">
  <app-list-view
    [dataSource]="dataSource"
    [columns]="columns"
    [actions]="actions"
    [compact]="false"
    [elevated]="false"
    id="InvoicesList"
  ></app-list-view>
</div>
